import React from 'react';
import { AG_NOTE, pointMethod, priorityInfo, statInfo } from '../../data/guide/statGuide';
import { PriorityBadge } from './PriorityBadge';
import type { StatPriority } from '../../types/classBuild';
const LEGEND: StatPriority[] = ['principal', 'complementaria', 'supervivencia', 'requisitos'];

/** Primero lo sencillo: qué hace cada estadística, qué significan las etiquetas y cómo repartir. */
export function StatBasics() {
  return <div className="grid gap-10 lg:grid-cols-[1.25fr_1fr] lg:gap-14" data-id="element-416" data-mp="269ll3e0oacfp">
      <section id="estadisticas" aria-labelledby="estadisticas-t" className="scroll-mt-24" data-id="element-417" data-mp="21aqz637es7rd">
        <h2 id="estadisticas-t" className="font-cinzel text-lg font-bold text-white md:text-2xl" data-id="element-418" data-mp="1wb4pu4upbbnu">
          Qué hace cada estadística
        </h2>
        <p className="mt-1 text-sm text-gray-400" data-id="element-419" data-mp="1rexgs370dk1o">Referencia general. Los efectos exactos dependen de la clase, la habilidad y la configuración del servidor.</p>
        <dl className="mt-4 divide-y divide-white/10 border-y border-white/10" data-id="element-420" data-mp="fwmlvb2yc3i4">
          {statInfo.map(s => <div key={s.key} className="grid gap-1 py-3 sm:grid-cols-[9rem_1fr] sm:gap-4" data-id="element-421" data-mp="2q1vzp6aybegc">
              <dt className="font-semibold text-white" data-id="element-422" data-mp="2uycrcahd0ay6">
                {s.name} <span className="text-xs font-normal text-[#D4AF37]" data-id="element-423" data-mp="2g2n98nfaohyq">{s.short}</span>
              </dt>
              <dd className="text-sm leading-relaxed text-gray-300" data-id="element-424" data-mp="2l0ylf4t2b4k4">{s.text}</dd>
            </div>)}
        </dl>
        <p className="mt-3 text-sm text-gray-300" data-id="element-425" data-mp="2791vn7ev96qw">
          <span className="font-semibold text-white" data-id="element-426" data-mp="2788q29rn8nac">AG ≠ Agilidad.</span> {AG_NOTE.replace('Agilidad y AG no son lo mismo: ', '')}
        </p>
      </section>

      <div className="space-y-10" data-id="element-427" data-mp="1xd8fle1xuv4d">
        <section aria-labelledby="etiquetas-t" data-id="element-428" data-mp="1xa2nrr1xdf4y">
          <h2 id="etiquetas-t" className="font-cinzel text-lg font-bold text-white md:text-2xl" data-id="element-429" data-mp="22c1pkwi0o3zs">
            Cómo leer las prioridades
          </h2>
          <ul className="mt-4 space-y-3" data-id="element-430" data-mp="1odlbullqld85">
            {LEGEND.map(p => <li key={p} className="flex items-start gap-3" data-id="element-431" data-mp="1sc1351oup7rd">
                <PriorityBadge p={p} className="w-[10.5rem] shrink-0 justify-center" data-id="element-432" data-mp="3uzrf1skkps25" />
                <span className="text-sm text-gray-300" data-id="element-433" data-mp="3q899ssbip5bd">{priorityInfo[p].text}</span>
              </li>)}
          </ul>
        </section>

        <section id="metodo" aria-labelledby="metodo-t" className="scroll-mt-24" data-id="element-434" data-mp="3l9xzyhl82ut5">
          <h2 id="metodo-t" className="font-cinzel text-lg font-bold text-white md:text-2xl" data-id="element-435" data-mp="3gc69zt451irl">
            Cómo repartir tus puntos
          </h2>
          <ol className="mt-4 space-y-3" data-id="element-436" data-mp="ctv191c38ggy">
            {pointMethod.map((m, i) => <li key={m.title} className="flex gap-3" data-id="element-437" data-mp="cs1wxsoy68c4" data-mpi={i}>
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-[#D4AF37]/50 text-xs font-bold text-[#D4AF37]" data-id="element-438" data-mp="7tgtzlib9ajz">{i + 1}</span>
                <span className="text-sm" data-id="element-439" data-mp="2sliog51auumk">
                  <span className="font-semibold text-white" data-id="element-440" data-mp="2smbxxdrn7y8e">{m.title}.</span> <span className="text-gray-300" data-id="element-441" data-mp="2oj5uedvx0l5m">{m.text}</span>
                </span>
              </li>)}
          </ol>
        </section>
      </div>
    </div>;
}